/* Countdown bis zum Datum in data-deadline (Ortszeit des Besuchers). */
(function () {
  var box = document.getElementById('countdown');
  if (!box) return;

  var deadline = new Date(box.dataset.deadline).getTime();
  // querySelectorAll, damit Original und Spiegelung gleichzeitig laufen
  var fields = {};
  ['days', 'hours', 'minutes', 'seconds'].forEach(function (key) {
    fields[key] = box.querySelectorAll('[data-cd="' + key + '"]');
  });

  function setz(key, text) {
    fields[key].forEach(function (el) { el.textContent = text; });
  }

  var pad = function (n) { return String(n).padStart(2, '0'); };

  function tick() {
    var diff = deadline - Date.now();

    if (diff <= 0) {
      box.classList.add('is-over');
      setz('days', '00');
      setz('hours', '00');
      setz('minutes', '00');
      setz('seconds', '00');
      clearInterval(timer);
      return;
    }

    var total = Math.floor(diff / 1000);
    setz('days', pad(Math.floor(total / 86400)));
    setz('hours', pad(Math.floor(total / 3600) % 24));
    setz('minutes', pad(Math.floor(total / 60) % 60));
    setz('seconds', pad(total % 60));
  }

  tick();
  var timer = setInterval(tick, 1000);
})();
